import NextLink from 'next/link'
import { Button as BaseButton, ButtonProps as BaseButtonProps } from '@careguide/button'
import { FC } from 'react'

type ButtonProps = BaseButtonProps & {
  scroll?: boolean
  replace?: boolean
}

const Button: FC<ButtonProps> = ({ href, children, scroll = true, replace = false, ...rest }) => {
  return href ? (
    <NextLink href={href} scroll={scroll} replace={replace} passHref>
      <BaseButton as='a' {...rest}>
        {children}
      </BaseButton>
    </NextLink>
  ) : (
    <BaseButton as='button' {...rest}>
      {children}
    </BaseButton>
  )
}

export default Button
